import request from '@/utils/request'

// 取消指派操作员
export function unassignOperator(data) {
  return request({
    url: '/account/bank/unassignOperator',
    method: 'post',
    data: data,
  })
}

// 指派操作员
export function assignOperator(data) {
  return request({
    url: '/account/bank/assignOperator',
    method: 'post',
    data: data,
  })
}

// 编辑银行种类
export function updateAmsBankSetting(data) {
  return request({
    url: '/account/bank/updateAmsBankSetting',
    method: 'post',
    data: data,
  })
}

// 新增银行种类
export function addAmsBankSetting(data) {
  return request({
    url: '/account/bank/addAmsBankSetting',
    method: 'post',
    data: data,
  })
}

// 银行种类列表
export function listAmsBankSettings(params) {
  return request({
    url: '/account/bank/listAmsBankSettings',
    method: 'get',
    params: params,
  })
}

export function editBank(data) {
  return request({
    url: `/account/bank/updateBankAccount/${data.accId}`,
    method: 'patch',
    data: data,
  })
}

export function addBank(data) {
  return request({
    url: '/account/bank/addBankAccount',
    method: 'post',
    data: data,
  })
}

export function getBankList() {
  return request({
    url: '/account/bank/bankList',
    method: 'get',
  })
}

export function getBankReport() {
  return request({
    url: '/account/bank/report',
    method: 'get',
  })
}

// 获取银行帐户验证码
export function getBankAccountVerificationCode(accId) {
  return request({
    url: `/account/bank/bankAccountVerificationCode/${accId}`,
    method: 'get',
  })
}

// 获取银行列表
export function getBankLists(params) {
  return request({
    url: '/account/bank/listBanks',
    method: 'get',
    params: params,
  })
}

// 拉银行流水列表
export function createBankCardTurnover(data) {
  return request({
    url: '/account/bank/createBankCardTurnover',
    method: 'post',
    data: data,
  })
}

// 转移用户银行帐户
export function transferUserBankAccount(data) {
  return request({
    url: '/account/bank/transferUserBankAccount',
    method: 'post',
    data: data,
  })
}

/* =============== Start 短信模版管理 =============== */
// 新增短信模板
export function addTemplate(data) {
  return request({
    url: '/bank/sms/template/addTemplate',
    method: 'post',
    data: data,
  })
}
// 短信模板列表
export function listTemplates(params) {
  return request({
    url: '/bank/sms/template/listTemplates',
    method: 'get',
    params: params,
  })
}
// 全部的短信模板列表
export function listAllTemplate(params) {
  return request({
    url: '/bank/sms/template/allTemplate',
    method: 'get',
    params: params,
  })
}
// 获取短信模板对应的Regex Group Name列表
export function listTemplateRegexGroupNames(params) {
  return request({
    url: '/bank/sms/template/listTemplateRegexGroupNames',
    method: 'get',
    params: params,
  })
}
// 更新短信模版
export function updateTemplate(data) {
  return request({
    url: `/bank/sms/template/updateTemplate/${data.id}`,
    method: 'patch',
    data: data,
  })
}
// 删除短信模版
export function deleteTemplate(data) {
  return request({
    url: `/bank/sms/template/deleteTemplate/${data.id}`,
    method: 'delete',
  })
}
// 热更新短信解析器
export function hotUpdateForSmsParser(data) {
  return request({
    url: '/bank/sms/template/hotUpdateForSmsParser',
    method: 'post',
    data: data,
  })
}
/* =============== Start 短信实例 =============== */
// 新增短信实例
export function addInstance(data) {
  return request({
    url: '/bank/sms/instance/addInstance',
    method: 'post',
    data: data,
  })
}
// 短信实例列表
export function listInstances(params) {
  return request({
    url: '/bank/sms/instance/listInstances',
    method: 'get',
    params: params,
  })
}
// 更新短信实例
export function updateInstance(data) {
  return request({
    url: `/bank/sms/instance/updateInstance/${data.id}`,
    method: 'patch',
    data: data,
  })
}
// 删除短信实例
export function deleteInstance(data) {
  return request({
    url: `/bank/sms/instance/deleteInstance/${data.id}`,
    method: 'delete',
  })
}

// 客制化测试Regex
export function smsTestCustomTestingRegex(data) {
  return request({
    url: '/bank/sms/test/customTestingRegex',
    method: 'post',
    data: data,
  })
}

// Sms客制化测试Regex
export function smsTestCustomTestingRegexForSms(data) {
  return request({
    url: '/bank/sms/test/customTestingRegexForSms',
    method: 'post',
    data: data,
  })
}
/* =============== End 短信模版管理 =============== */


// WEBPACK FOOTER //
// ./src/api/bank.js